var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0679 4.65713L1.51311 1.14776C1.40647 1.04248 1.25835 0.978138 1.09246 0.978138C0.766609 0.978138 0.5 1.24134 0.5 1.56303C0.5 1.7268 0.565172 1.87302 0.671815 1.9783L3.81187 5.0724L0.677741 8.1665C0.565173 8.27178 0.5 8.418 0.5 8.58177C0.5 8.90346 0.766609 9.16667 1.09246 9.16667C1.25835 9.16667 1.40647 9.10232 1.51311 8.99704L5.0679 5.48767C5.17454 5.38239 5.23971 5.23617 5.23971 5.0724C5.23971 4.90863 5.17454 4.76241 5.0679 4.65713Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.74743656.svg";
export { ForwardRef as ReactComponent };